<form (ngSubmit)="onSubmit()" [formGroup]="form" class="d-flex flex-column gap-20">
  <div [hidden]="!loading" class="spinner">
    <div class="sk-spinner sk-spinner-pulse"></div>
  </div>
  <div class="form-group">
    <label class="form-label required">Name </label>
    <input formControlName="name" type="text" class="form-control" required>
    <input-errors [control]="form.controls.name" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label required">MCC </label>
    <input formControlName="mcc" type="text" class="form-control" required>
    <input-errors [control]="form.controls.mcc" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label required">MNC </label>
    <input formControlName="mnc" type="text" class="form-control" required>
    <input-errors [control]="form.controls.mnc" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label">Prefixes</label>
    <input formControlName="prefixes" type="text" class="form-control" placeholder="Separate multiple prefixes by comma" />
    <input-errors [control]="form.controls.prefixes" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label required">Country </label>
    <select formControlName="countryId" class="form-control">
      <option *ngFor="let country of countries" [value]="country.id">{{ country.name }}</option>
    </select>
    <input-errors [control]="form.controls.countryId" [service]="validationService"></input-errors>
  </div>
  <div class="form-group">
    <label class="form-label required">Aggregator </label>
    <div class="form-check form-switch">
      <input type="checkbox" class="form-check-input medium" formControlName="aggregator" />
    </div>
  </div>

  <div class="text-right my-10">
    <a *ngIf="backButtonShow" href="javascript:history.back();" class="btn btn-danger px-20">Cancel</a>
    <button id="btn-sender-apply" type="submit" [disabled]="!form.valid" class="btn btn-primary px-20">Apply</button>
  </div>
</form>
